/*
  "You may also like" on the PDP. Fetches sections/api-ph-recommendations.liquid
  through the product recommendations endpoint (Search & Discovery), filters out
  the source product's variant family, renders at most data-max rows, and hands
  add-to-basket clicks to the theme.

  The family filter runs in both directions because custom.variant_products is
  not always symmetric (see snippets/product-sizes.liquid):
    - drop a row whose product id is in the source's data-family-ids
    - drop a row whose own data-family-ids contains the source product

  Add buttons dispatch the theme's own 'theme:cart:add' with the button in
  detail, exactly as quick add does (theme.dev.js, ProductAddButton). The theme's
  CartItems element then posts the button's form to /cart/add, refetches
  ?section_id=api-cart-items, patches the drawer, and its build() dispatches
  'theme:cart:change' (header count) and 'theme:product:added' (opens the
  drawer). Nothing here touches the cart directly, so the flow can never drift
  from the theme's.
*/
(function () {
  'use strict';

  var SELECTORS = {
    holder: '[data-ph-recommendations]',
    rows: '[data-ph-rec-rows]',
    row: '[data-ph-rec-row]',
    add: '[data-ph-rec-add]',
    apiContent: '[data-api-content]',
  };

  function parseIds(value) {
    var ids = [];
    try {
      ids = JSON.parse(value || '[]');
    } catch (e) {
      ids = [];
    }
    return ids.map(String);
  }

  function init(holder) {
    if (holder.hasAttribute('data-ph-rec-init')) return;
    holder.setAttribute('data-ph-rec-init', '');

    var productId = String(holder.getAttribute('data-product-id') || '');
    var familyIds = parseIds(holder.getAttribute('data-family-ids'));
    var limit = parseInt(holder.getAttribute('data-limit'), 10) || 10;
    var max = parseInt(holder.getAttribute('data-max'), 10) || 3;

    if (!productId) {
      holder.remove();
      return;
    }

    var base =
      (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) ||
      '/recommendations/products';
    var url = base + '?section_id=api-ph-recommendations&product_id=' + productId + '&limit=' + limit + '&intent=related';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('ph-recommendations: HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var content = doc.querySelector(SELECTORS.apiContent);
        if (!content) throw new Error('ph-recommendations: no api content');

        var rows = Array.prototype.slice.call(content.querySelectorAll(SELECTORS.row));
        var kept = rows
          .filter(function (row) {
            var rowId = String(row.getAttribute('data-product-id') || '');
            if (familyIds.indexOf(rowId) !== -1) return false;
            if (parseIds(row.getAttribute('data-family-ids')).indexOf(productId) !== -1) return false;
            return true;
          })
          .slice(0, max);

        holder.setAttribute('data-ph-rec-kept', String(kept.length));

        if (!kept.length) {
          holder.remove();
          return;
        }

        var target = holder.querySelector(SELECTORS.rows);
        kept.forEach(function (row) {
          target.appendChild(row);
        });

        bindAddButtons(target);
        holder.removeAttribute('hidden');
      })
      .catch(function () {
        // No recommendations is a quiet state, never a broken block.
        holder.remove();
      });
  }

  function bindAddButtons(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTORS.add), function (button) {
      // The theme re-enables cart-context buttons only, so clear our own state
      // on the events it dispatches back on the button, with a timeout in case
      // neither arrives.
      var reset = function () {
        window.setTimeout(function () {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.classList.remove('is-added');
        }, 1200);
      };
      button.addEventListener('theme:product:add', reset);
      button.addEventListener('theme:product:add-error', reset);

      button.addEventListener('click', function (event) {
        // The custom element must be UPGRADED, not merely present: the tag
        // exists in the parsed HTML long before theme.js executes, and a click
        // in that window dispatched theme:cart:add into the void - a dead
        // button on slow connections (red team, reproduced). Either condition
        // failing falls back to the form's native post to /cart/add, which
        // works without JavaScript at all.
        if (!customElements.get('cart-items') || !document.querySelector('cart-items')) return;

        event.preventDefault();

        if (window.a11y) window.a11y.lastElement = button;

        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: {
              button: button,
            },
          })
        );

        // Deliberately NOT reset() here: calling it from the click re-enabled
        // the button 1200ms in even with the add still in flight, and a second
        // click doubled the order line (red team, reproduced). The add/add-error
        // listeners do the real reset; this is only the safety net for the case
        // where neither event ever arrives.
        window.setTimeout(reset, 5000);
      });
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTORS.holder), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme editor re-renders rebuild the PDP DOM; without this the fresh holder
  // stays hidden forever and the block vanishes in the customiser (red team).
  // init() is idempotent, so re-running over the new subtree is safe.
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(
      (e.target || document).querySelectorAll(SELECTORS.holder), init
    );
  });
})();
